import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, indicacao } = obj
  const response = await http[verb]('/indicacoes', indicacao)
  if (response !== null) {
    indicacao.id = response.data.id
    update(context, { ...indicacao })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/indicacoes/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }, login) => {
  const response = await http.get('/indicacoes/login?login=' + login)
  if (response !== null) {
    const indicacoes = response.data
    commit('SET_LIST', indicacoes)
    commit('SET_SALDO', indicacoes)
    
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { indicacoes: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/indicacoes/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/features/admin/indicacoes/store/actions.js